import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=1b9b88b8&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerForm.vue?vue&type=style&index=0&id=1b9b88b8&prod&scoped=true&lang=css"
import style1 from "./CustomerForm.vue?vue&type=style&index=1&id=1b9b88b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9b88b8",
  null
  
)

export default component.exports